module.exports = __webpack_public_path__ + "static/img/hoverlogo07.3d06e7bb.png";